import { render } from "./PatientAreaTabs.vue?vue&type=template&id=55901cf6&scoped=true"
import script from "./PatientAreaTabs.vue?vue&type=script&lang=js"
export * from "./PatientAreaTabs.vue?vue&type=script&lang=js"

import "./PatientAreaTabs.vue?vue&type=style&index=0&id=55901cf6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55901cf6"]])

export default __exports__